










import translations from '@/requests/staticTranslationsQuery'

export default {
  name: 'CLiveIndicator',
  props: {
    isLive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      translations
    }
  }
}
